import React from 'react';
import {Link} from "react-router-dom";
import {TopTabs} from "./top-tabs/Top-tabs";
import {Controls} from "./top-controls/Controls";
import {GroupSettings} from "./top-controls/controls-settings/Group-settings";
import {OnlineTabs} from "components/pages/groups/online-communication/online-tabs/OnlineTabs";
import {TestTabs} from "../../../test/test-tabs/Test-tabs";
import {PaymentTabs} from "../../../payment-history/payment-tabs/PaymentTabs";
import {TestStudentTabs} from "components/pages/test/students-test/separate-test/separate-test-table/test-tabs/TestTabs";
import {useAppSelector} from "common/hook";
import {OnlineEdit} from "components/pages/groups/online-communication/online-tabs/online-edit/OnlineEdit";
import {OnlineEditTest} from "components/pages/groups/online-communication/online-tabs/online-edit-test/OnlineEditTest";
import {ROLE_TEACHER} from "entities/constants/constants";

interface IMainTop {
    title: string  | React.ReactNode
    tabs: boolean
    onlineTabs?: boolean
    setting: boolean
    edit?: boolean
    editTest?:boolean
    test?: boolean
    testStudent?: boolean
    payment?: boolean
    link: string
    icons?: React.ReactNode;
}

export const MainTop = (
    {
        title,
        tabs,
        setting,
        edit,
        editTest,
        test,
        testStudent,
        link,
        icons,
        onlineTabs,
        payment
    }
        : IMainTop) => {
    const roleType = useAppSelector((state) => state.role.roleType);
    return (
        <div className="app-main-hdr">
            <div className="main-col col">
                {icons &&
                    <h1 className="app-page-title h3">{title}
                        <Link to={link} className="title-icon light-gradient-bg">
                            {icons}
                        </Link>
                    </h1>
                }
                {!icons &&
                    <h1 className="app-page-title no-icon  h3">{title}</h1>
                }
                {tabs && <TopTabs/>}
                {onlineTabs && <OnlineTabs/>}
                {test && <TestTabs/>}
                {testStudent && <TestStudentTabs/>}
                {payment && <PaymentTabs/>}
            </div>

            <div className='group-setting-block'>
                <Controls/>
                {roleType === ROLE_TEACHER &&
                    <>
                        {setting && <GroupSettings/>}
                        {edit && <OnlineEdit/>}
                        {editTest && <OnlineEditTest/>}
                    </>
                }
            </div>
        </div>
    );
};

